import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { User } from 'src/app/calvin-emr-shared/models/user.model';
import {
  PATH_SETTINGS_PROFILE,
  PATH_SETTINGS_HELP,
  PATH_CHANGE_PASSWORD,
} from '../settings.global';
import { AuthStore } from 'src/app/calvin-emr-shared/state/auth/auth.store';
import { MenuModule } from 'primeng/menu';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-settings-page',
    templateUrl: './settings-page.component.html',
    styleUrls: ['./settings-page.component.scss'],
    standalone: true,
    imports: [MenuModule, RouterOutlet],
})
export class SettingsPageComponent implements OnInit, OnDestroy {
  changePasswordPath = '/' + PATH_CHANGE_PASSWORD;

  currentUser?: User;

  menuItems: MenuItem[] = [
    {
      label: 'My Profile',
      icon: 'pi pi-fw pi-user',
      routerLink: PATH_SETTINGS_PROFILE,
    },
    { separator: true },
    {
      label: 'Help',
      icon: 'pi pi-fw pi-question-circle',
      routerLink: PATH_SETTINGS_HELP,
    },
  ];

  private authStore = inject(AuthStore);

  constructor() {
    const user = this.authStore.user();
    if (user) {
      this.currentUser = user;
    }
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}
}
